/* ============================================================================
   Lab index
   Two jobs: the page's own entry animation, and mounting the Vocabulary
   playground — which is where the motion language actually gets argued about.
   The playground reads motion.css at runtime, so the reference can never drift
   from what the experiments run.
   ========================================================================= */

import { initMotion, isReduced, MOTION, hasOverrides } from './motion.js';
import { mountLabBar } from './lab.js';
import { mountVocabulary } from './vocabulary.js';

const { gsap } = initMotion();
mountLabBar({ title: 'Index' });

mountVocabulary({ root: document.querySelector('[data-vocabulary]'), gsap });

/* --- Tuned-token notice ----------------------------------------------------
   Token overrides from the playground persist across pages, which is the
   point — but it also means someone can review the PDP against numbers that
   aren't in motion.css and not realise it. Say so on the way in. */
if (hasOverrides()) {
  const flag = document.createElement('p');
  flag.className = 'home__hint home__hint--tuned';
  flag.innerHTML =
    'Tokens are currently <b>tuned</b> in this browser and apply to every ' +
    'experiment. Open <a href="#vocabulary">the Token studio</a> to export or reset them.';
  document.querySelector('.home__head').append(flag);
}

/* --- Page entry ------------------------------------------------------------ */
function build() {
  const intro = gsap.utils.toArray('[data-intro]');
  const cards = gsap.utils.toArray('[data-exp]');

  if (isReduced()) {
    gsap.set([...intro, ...cards], { opacity: 1, y: 0, clearProps: 'transform' });
    return;
  }

  gsap.set(intro, { opacity: 0, y: MOTION.rise.sm });
  gsap.set(cards, { opacity: 0, y: MOTION.rise.md });

  gsap
    .timeline()
    .to(intro, {
      opacity: 1,
      y: 0,
      duration: MOTION.dur.slow,
      stagger: MOTION.stagger.base,
    })
    .to(
      cards,
      {
        opacity: 1,
        y: 0,
        duration: MOTION.dur.slow,
        stagger: MOTION.stagger.base,
      },
      '-=0.4'
    );
}

build();
window.addEventListener('mo:replay', build);
